import { LocalStorage } from "ttl-localstorage";

class CacheFactory {
  async getOrCreateDataFromCache(callbackLoadingData) {
    const CACHE_KEY = "SITES";
    const CACHE_TIMEOUT = 86400;

    const isCacheExist = await LocalStorage.keyExists(CACHE_KEY);
    if (!isCacheExist) {
      LocalStorage.put(CACHE_KEY, await callbackLoadingData(), CACHE_TIMEOUT);
    }

    return await LocalStorage.get(CACHE_KEY);
  }
}

export default new CacheFactory();
